<template>
  <div>
    <h3 class="title is-4">Comments</h3>
    <div class="columns">
      <div class="column">
        <section class="comment">
          <label class="lable line"> <i class="fa fa-user"></i> Chamara Abeysekar says</label>
          <br>
          <br>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum optio delectus odio consectetur eos debitis sit quia maxime dolores. Qui cumque quidem iusto nostrum recusandae sequi harum saepe ullam ipsam.</p>
        </section>
        <section class="comment">
          <label class="lable line"> <i class="fa fa-user"></i> Chamara Abeysekar says</label>
          <br>
          <br>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum optio delectus odio consectetur eos debitis sit quia maxime dolores. Qui cumque quidem iusto nostrum recusandae sequi harum saepe ullam ipsam.</p>
        </section>
      </div>
    </div>

    <h3 class="title is-4">Leave Comment</h3>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Name</label>
          <div class="control has-icons-left has-icons-right">
            <input class="input" type="text">
            <span class="icon is-small is-left">
              <i class="fa fa-user"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Email</label>
          <div class="control has-icons-left has-icons-right">
            <input class="input" type="email">
            <span class="icon is-small is-left">
              <i class="fa fa-envelope"></i>
            </span>
          </div>
        </div>
      </div>


    </div>

    <div class="columns">
      <div class="column">
        <label class="label">Comment</label>
        <textarea class="textarea" ></textarea>
        <br>
        <touch-ripple :speed="1" :opacity="0.1" color="#fff" transition="ease">
        <button class="button is-puple">
          <i class="fa fa-send"></i>
        </button>
        </touch-ripple>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name : "Comment"
  }
</script>

<style lang="scss">
@import '../../static/styles.scss';
@import '../../static/_variables.scss';

.comment{
  padding: 1em;
  border: 1px solid $stipe-color;
  margin-bottom: 1em;

  .lable {
    margin-bottom: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/componests/Comment.vue